import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20product%20photography%20flat%20lay%20with%20neutral%20beige%20cream%20clothing%20items%20and%20accessories%20arranged%20on%20light%20background%2C%20soft%20natural%20daylight%2C%20minimal%20clean%20aesthetic%2C%20high%20end%20fashion%20catalog%20style%2C%20pastel%20earth%20tones%2C%20serene%20composition%2C%20shallow%20depth%20of%20field%2C%20warm%20bokeh%20effect%2C%20organic%20textures%2C%20lifestyle%20vibes%2C%208k%20detailed&width=1600&height=900&seq=hero-bg-kakobuy-02&orientation=landscape"
        alt="Kakobuy Spreadsheet lifestyle product photography"
        title="Kakobuy Spreadsheet - Verified Product Finds Database"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            Kakobuy Spreadsheet
          </h1>
          <p className="text-lg md:text-xl text-background-50/85 font-light mb-3">
            The Ultimate Database For Verified Finds
          </p>
          <p className="text-sm md:text-base text-background-50/60 font-light max-w-lg mb-8">
            Discover thousands of organized product finds, updated spreadsheets, category guides, and shopping resources in one powerful platform.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap"
            >
              Kakobuy Sheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <Link
              to="/kakobuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap"
            >
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="flex flex-wrap items-center gap-6 mt-8">
            {['Updated Daily', 'Organized Categories', 'Community Verified', 'Shopping Guides'].map((badge) => (
              <span key={badge} className="flex items-center gap-1.5 text-xs text-background-50/70">
                <i className="ri-check-line text-accent-400 text-xs"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}